module.exports = __webpack_public_path__ + "static/media/17.a06d05ea.jpg";